import React from 'react'
import ReactDOM from 'react-dom'
import UrlManager from '~/util/url_manager'
import striptags from 'striptags'
import excerpt from 'excerpt'
import Highlighter from '~/util/highlighter'

const highlighter = new Highlighter()


export default class BlogCell extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const blogText = highlighter.highlight(excerpt(
      striptags(this.props.blog.content),
      this.props.searchWords, 50
    ), this.props.searchWords)
    const thumbnail = this.props.blog.photo.thumb.url ? {
      backgroundImage: `url(${this.props.blog.photo.thumb.url})`
    } : {}
    const blogTitle = highlighter.highlight(this.props.blog.title, this.props.searchWords)
    return (
      <li className="blog_cell">
        <div className="blogtitle">
          <a href={this.props.blog.show_path}>
            <span>
              <span className="cell_thumb" style={thumbnail}>
              </span>
            </span>
          </a>
        </div>
        <div className="blogright">
          <a href={this.props.blog.show_path}>
            <h3 className="title" dangerouslySetInnerHTML={{__html: blogTitle}}/>
          </a>
          <span className="inner" dangerouslySetInnerHTML={{__html: blogText}}/>
        </div>
      </li>
    )
  }
}
